/**
 * The **drop-time Boost card** (`move-family-opt-in-surface` Phase 1): a PLAY drop that folds a
 * Boost whose riders are non-empty holds its ghost at the drop cell, and this card asks before the
 * move is sent. It is the command menu's Boost card body (`BoostRiderControls`: the same checkboxes,
 * each starting at its authored default) with BOOST & MOVE and CANCEL, placed beside the drop cell
 * the way the Inspect readout is (`InspectReadoutFrame`).
 */
import type { OptInActionRiderPrompt, SquareCell } from "@lancer-vtt/domain";
import { BoostRiderControls } from "../../../lib/encounter/combatWindows/unitActions";
import { InspectReadoutFrame } from "./InspectReadoutFrame";

const FRAME = { className: "combat-boost-drop skirmish-hud", role: "dialog", label: "boost card" };
const GO = { label: "BOOST & MOVE", ariaLabel: "boost and move" };

export function BoostDropCard({
  cell,
  view,
  stage,
  riders,
  onConfirm,
  onCancel,
}: {
  cell: SquareCell;
  view: { x: number; y: number; scale: number };
  stage: { width: number; height: number };
  riders: OptInActionRiderPrompt[];
  onConfirm: (choices: Record<string, string>) => void;
  onCancel: () => void;
}) {
  return (
    <InspectReadoutFrame cell={cell} view={view} stage={stage} frame={FRAME}>
      <div className="skirmish-hud-head">
        <span className="skirmish-hud-title">BOOST</span>
      </div>
      <BoostRiderControls riders={riders} blockReason={undefined} onBoost={onConfirm} go={GO} onCancel={onCancel} />
    </InspectReadoutFrame>
  );
}
